function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.646,
    height: 128.251,
    viewBox: "0 0 34.038 33.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    ry: 16.966,
    rx: 17.019,
    cy: 12.254,
    cx: 12.201,
    style: {
      fill: "#fff",
      strokeWidth: 0.26060441
    },
    transform: "translate(4.818 4.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.616 46.018h.001-.001m.001 0h.002zm.002 0v.002-.001m10.372 14.894c-1.22.161-2.468.132-3.712-.094a11.903 11.903 0 0 1-7.574-4.78c-.24-.29-2.203-2.803-1.692-7.018.247-2.046.814-3.371 1.682-3.939.556-.362 1.046-.3 1.223-.259 1.03.18 1.456 1.374 1.596 1.77.284.8.473 1.8.656 2.768.151.798.294 1.553.477 2.14.215.688.39.825.421.844h.004c.062-.01.196-.154.31-.622.13-.539.18-1.286.228-2.009.052-.779.105-1.584.264-2.223.227-.92.674-1.431 1.33-1.518.797-.105 1.298.485 1.577.998.275.505.475 1.155.67 1.784.14.457.272.887.42 1.228.148.338.253.446.29.476.081-.013.124-.04.178-.163.088-.202.128-.525.17-.866.062-.511.134-1.09.407-1.586.348-.633.938-.987 1.755-1.05.98-.077 1.31.009 2.288.263.58.15 1.458.378 2.919.687 1.443.305 2.432.22 2.786-.242.425-.551.037-1.771-.216-2.275a.636.636 0 0 1-.025-.055 10.803 10.803 0 0 0-3.108-4.345 10.727 10.727 0 0 0-4.985-2.339 10.69 10.69 0 0 0-5.988.63 10.762 10.762 0 0 0-4.61 3.617.616.616 0 0 1-.997-.726 11.99 11.99 0 0 1 5.138-4.032 11.921 11.921 0 0 1 6.676-.703 11.96 11.96 0 0 1 5.56 2.609 12.038 12.038 0 0 1 3.454 4.817c.163.333 1.052 2.29.079 3.555-.679.882-2.031 1.116-4.02.696-1.487-.315-2.38-.547-2.972-.7-.94-.244-1.109-.288-1.884-.228-.776.061-.9.475-1.033 1.558-.052.413-.104.84-.264 1.207-.283.651-.793.848-1.17.898-.4.053-.972-.067-1.428-.937-.238-.455-.422-1.053-.6-1.631-.175-.571-.357-1.16-.573-1.556-.1-.185-.24-.378-.333-.366-.074.01-.197.199-.294.59-.132.535-.182 1.284-.23 2.01-.052.775-.105 1.576-.261 2.218-.222.914-.658 1.433-1.294 1.545-.421.075-.827-.064-1.143-.39-.218-.225-.403-.545-.565-.98-.261-.704-.435-1.625-.62-2.6-.174-.92-.354-1.873-.606-2.584-.295-.829-.553-.953-.65-.968-.02-.002-.038-.007-.056-.01-.027-.004-.15-.009-.322.121-.296.224-.831.914-1.087 3.022-.467 3.855 1.403 6.064 1.421 6.086a.577.577 0 0 1 .036.044 10.673 10.673 0 0 0 6.806 4.305c2.322.422 4.659.082 6.758-.981a10.798 10.798 0 0 0 2.872-2.122c.8-.835 1.462-1.795 1.958-2.84l.883-1.755c.13-.31.439-.775.75-.652.312.125.513.657.396.97-.118.316-.52 1.263-.665 1.566l-.102.245a.362.362 0 0 1-.018.038c-.527 1.043-1.45 2.378-2.256 3.223a11.78 11.78 0 0 1-.965.913.635.635 0 0 1-.072.053 11.98 11.98 0 0 1-6.048 2.65",
    style: {
      fill: "#cc1e26",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#cc1e26",
      strokeWidth: 0.7826376,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-83.72 -31.977)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnote);
export default __webpack_public_path__ + "static/media/ANOTE.e85670ea9ed23dcc6ca32fdf8ab2b9a7.svg";
export { ForwardRef as ReactComponent };